import React, {
  useMemo,
  useState,
  useCallback,
  useEffect
} from 'react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import Shipment from '../../../components/Shipment';
import Incoming from '../../../components/Incoming';
import PopupActMVP from '../../../components/PopupActMVP';
import Reports from '../../../components/Reports';
// import StockMetric from '../../../components/StockMetric';
import QRCodeTab from '../../../components/QRCodeTab';
import styles from '../stocktabpanel.module.scss';
import ResponsiblePerson from '../../../components/ResponsiblePerson';
import EditAct from '../../../components/EditAct';
import EditTtn from '../../../components/EditTtn';
import SalesOrders from '../../../components/SalesOrders';
import MessagesAdmin from '../../../components/AdminTabList/MessagesAdmin';

const StockTabPanel = ({
  isAutoAcceptIncoming,
  isOffBalanceSheet,
  isUseFIFO,
  isUseM4,
  isUseAZH,
  isUseMhOnExpeditor,
  isUseProhibitionShipping,
  isUseShippingVehicleOnly,
  plantId,
  sapCode,
  showTranspOrder,
  tabsListState
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const savedTabSelect = Number(localStorage.getItem('tabSelect'));

  useEffect(() => {
    if ((savedTabSelect || savedTabSelect === 0)
    && tabsListState.map((item) => item.id).includes(savedTabSelect)) {
      setSelectedIndex(savedTabSelect);
    }
  }, [savedTabSelect, tabsListState]);

  const shipment = useMemo(() => () => (
    <>
      <Shipment isOffBalanceSheet={isOffBalanceSheet}
                isUseFIFO={isUseFIFO}
                isUseM4={isUseM4}
                isUseMhOnExpeditor={isUseMhOnExpeditor}
                isUseProhibitionShipping={isUseProhibitionShipping}
                plantId={plantId}
                sapCode={sapCode}
                showTranspOrder={showTranspOrder}
      />
    </>
  ), [
    isOffBalanceSheet,
    isUseFIFO,
    isUseM4,
    isUseMhOnExpeditor,
    isUseProhibitionShipping,
    plantId,
    sapCode,
    showTranspOrder
  ]);
  const incoming = useMemo(() => () => (
    <>
      <Incoming plantId={plantId}
                showTranspOrder={showTranspOrder}
                isUseMhOnExpeditor={isUseMhOnExpeditor}
                isUseM4={isUseM4}
      />
    </>
  ), [plantId, showTranspOrder, isUseM4, isUseMhOnExpeditor]);

  const reports = useMemo(() => () => (
    <Reports plantId={plantId} typeStock={0} isOffBalanceSheet={isOffBalanceSheet} />
  ), [isOffBalanceSheet, plantId]);

  // const stockMetric = useMemo(() => () => (
  //   <StockMetric plantId={plantId} typeStock={0} />
  // ), [plantId]);

  const qrCodeTab = useMemo(() => () => (
    <QRCodeTab plantId={plantId}
               shippingType={0}
               showTranspOrder={showTranspOrder}
               isUseMhOnExpeditor={isUseMhOnExpeditor}
               isUseM4={isUseM4}
    />
  ), [
    plantId,
    showTranspOrder,
    isUseMhOnExpeditor,
    isUseM4
  ]);

  const responsiblePerson = useMemo(() => () => (
    <ResponsiblePerson plantId={plantId} shippingType={0} />
  ), [plantId]);

  const editAct = useMemo(() => () => (
    <>
      <EditAct plantId={plantId} shippingType={0} />
    </>
  ), [plantId]);

  const orders = useMemo(() => () => (
    <SalesOrders plantId={plantId} />
  ), [plantId]);

  const editTtn = useMemo(() => () => (
    <>
      <EditTtn plantId={plantId} />
    </>
  ), [plantId]);

  const messagesAdmin = useMemo(() => () => (
    <>
      <MessagesAdmin plantId={plantId} />
    </>
  ), [plantId]);

  const onSelectionChanged = useCallback(({
    name,
    value
  }) => {
    if (name === 'selectedIndex') {
      setSelectedIndex(value);
    }
  }, []);

  return (
    <>
      <PopupActMVP isUseM4={isUseM4} isUseAZH={isUseAZH} />
      <TabPanel selectedIndex={selectedIndex}
                onOptionChanged={onSelectionChanged}
                elementAttr={{ class: styles.tabs }}
                deferRendering={false}
                repaintChangesOnly
      >
        <Item render={shipment} />
        <Item render={incoming} disabled={isAutoAcceptIncoming ? 'true' : ''} />
        <Item render={reports} />
        {/* <Item render={stockMetric} /> */}
        <Item />
        <Item render={qrCodeTab} />
        {/* временно отключили по просьбе Саблиной Алевтины,
        после релиза 6.7 решили включить всем */}
        <Item render={responsiblePerson} />
        <Item render={editAct} />
        {/* вкладка "Заказы" имеет tabSelect=11, так что вводим дополнительные Item,
        чтобы "Заказы" была 11-ой, начиная с 0  */}
        <Item />
        <Item />
        <Item />
        <Item />
        <Item render={orders} />
        <Item render={editTtn} />
        <Item render={messagesAdmin} />
      </TabPanel>
    </>

  );
};

export default StockTabPanel;
